// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kbaAuthentication_kbaContainer__3tVGB {
    width: 100%;
    height: 100vh;
    background-color: #fff;
    display: grid;
    grid-template-columns: 1.3fr 1fr;
}

.kbaAuthentication_kbaImage__OO-IT {
    width: 100%;
    height: 100%;
    background-color: #605fef;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    position: relative;
    display: flex;
    align-items: flex-end;
}

.kbaAuthentication_kbaImageLogo__tYgeC {
    position: absolute;
    left: 40px;
    top: 40px;
}

.kbaAuthentication_kbaImageDetails__mPdEx {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    width: 100%;
}

.kbaAuthentication_kbaImageDetailsText__Vuo3N {
    padding-left: 40px;
    padding-bottom: 200px;
    max-width: 450px;
}

.kbaAuthentication_kbaImageDetailsText__Vuo3N h3 {
    color: #fff !important;
    font-weight: 900;
}

.kbaAuthentication_kbaImageDetailsText__Vuo3N p {
    color: #fff !important;
    margin-top: 30px;
    font-weight: 500;
}

.kbaAuthentication_kbaBackToHome__BPbqF {
    display: flex;
    align-items: center;
    gap: 20px;
}

.kbaAuthentication_kbaBackToHome__BPbqF p {
    color: #000;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: 'Poppins', sans-serif;
    font-style: normal;
    font-weight: 700;
}

.kbaAuthentication_imageContainer__SCs93 {
    border-radius: 83.81px;
    background: #0a0d29;
    width: 70px;
    height: 50px;
    display: flex;
    justify-content: center;
}

.kbaAuthentication_kbaTitle__cgII9 {
    color: #5151f9;
    font-family: 'Poppins', sans-serif;
    font-size: 34px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 90px;
    margin-bottom: 24px;
}

.kbaAuthentication_kbaKnowledgeBasedText__G0o15 {
    margin-top: 34px;
    color: #475569;
    font-family: 'Poppins', sans-serif;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.kbaAuthentication_kbaBassaText__zRpWV {
    color: #475569;
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-top: 24px;
}

.kbaAuthentication_kbaRadioInputsContainer__80LMh {
    display: flex;
    flex-direction: column;
    margin-top: 24px;
    gap: 15px;
}
.kbaAuthentication_kbaRadioInputs__TSAxW {
    display: flex;
    gap: 10px;
    color: #475569;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    align-items: start;
}
.kbaAuthentication_kbaRadioInputs__TSAxW input,
.kbaAuthentication_kbaRadioInputs__TSAxW label {
    cursor: pointer;
}
.kbaAuthentication_kbaSubmit__LdKit {
    display: flex;
    width: 100%;
    padding: 14.222px 21.333px;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    background: #0a0d29;
    color: #fff;
    font-family: 'Poppins', sans-serif;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-top: 30px;
    border: none;
}

.kbaAuthentication_kbaContent__ege23 {
    padding: 80px 80px 0px 80px;
}

.kbaAuthentication_authSuccess__MeOc6 {
    margin-top: 20px;
    border-radius: 4px;
    border: 1px solid #5151f9;
    background: #fff;
    color: #5151f9;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 20px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 30px;
}

/* Responsive Styling */
@media (max-width: 768px) {
    .kbaAuthentication_kbaImageDetailsText__Vuo3N {
        padding-top: 200px;
        padding-bottom: 100px;
        padding-right: 40px;
    }

    .kbaAuthentication_kbaImageDetailsImage__ErcH2 {
        display: none;
    }

    .kbaAuthentication_kbaContent__ege23 {
        padding: 80px 40px 80px 40px;
    }
}

@media (max-width: 992px) {
    .kbaAuthentication_kbaContainer__3tVGB {
        min-height: 100vh;
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/kbaAuthentication/kbaAuthentication.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;IAC5B,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,6CAA6C;IAC7C,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,aAAa;IACb,SAAS;IACT,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;;IAEI,eAAe;AACnB;AACA;IACI,aAAa;IACb,WAAW;IACX,0BAA0B;IAC1B,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA,uBAAuB;AACvB;IACI;QACI,kBAAkB;QAClB,qBAAqB;QACrB,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,0BAA0B;IAC9B;AACJ","sourcesContent":[".kbaContainer {\n    width: 100%;\n    height: 100vh;\n    background-color: #fff;\n    display: grid;\n    grid-template-columns: 1.3fr 1fr;\n}\n\n.kbaImage {\n    width: 100%;\n    height: 100%;\n    background-color: #605fef;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    position: relative;\n    display: flex;\n    align-items: flex-end;\n}\n\n.kbaImageLogo {\n    position: absolute;\n    left: 40px;\n    top: 40px;\n}\n\n.kbaImageDetails {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.kbaImageDetailsText {\n    padding-left: 40px;\n    padding-bottom: 200px;\n    max-width: 450px;\n}\n\n.kbaImageDetailsText h3 {\n    color: #fff !important;\n    font-weight: 900;\n}\n\n.kbaImageDetailsText p {\n    color: #fff !important;\n    margin-top: 30px;\n    font-weight: 500;\n}\n\n.kbaBackToHome {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.kbaBackToHome p {\n    color: #000;\n    font-feature-settings: 'clig' off, 'liga' off;\n    font-family: 'Poppins', sans-serif;\n    font-style: normal;\n    font-weight: 700;\n}\n\n.imageContainer {\n    border-radius: 83.81px;\n    background: #0a0d29;\n    width: 70px;\n    height: 50px;\n    display: flex;\n    justify-content: center;\n}\n\n.kbaTitle {\n    color: #5151f9;\n    font-family: 'Poppins', sans-serif;\n    font-size: 34px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    margin-top: 90px;\n    margin-bottom: 24px;\n}\n\n.kbaKnowledgeBasedText {\n    margin-top: 34px;\n    color: #475569;\n    font-family: 'Poppins', sans-serif;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n}\n\n.kbaBassaText {\n    color: #475569;\n    font-family: 'Poppins', sans-serif;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    margin-top: 24px;\n}\n\n.kbaRadioInputsContainer {\n    display: flex;\n    flex-direction: column;\n    margin-top: 24px;\n    gap: 15px;\n}\n.kbaRadioInputs {\n    display: flex;\n    gap: 10px;\n    color: #475569;\n    font-family: 'Poppins', sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    align-items: start;\n}\n.kbaRadioInputs input,\n.kbaRadioInputs label {\n    cursor: pointer;\n}\n.kbaSubmit {\n    display: flex;\n    width: 100%;\n    padding: 14.222px 21.333px;\n    justify-content: center;\n    align-items: center;\n    border-radius: 20px;\n    background: #0a0d29;\n    color: #fff;\n    font-family: 'Poppins', sans-serif;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    margin-top: 30px;\n    border: none;\n}\n\n.kbaContent {\n    padding: 80px 80px 0px 80px;\n}\n\n.authSuccess {\n    margin-top: 20px;\n    border-radius: 4px;\n    border: 1px solid #5151f9;\n    background: #fff;\n    color: #5151f9;\n    font-family: 'Poppins', sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    padding: 20px 0px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 30px;\n}\n\n/* Responsive Styling */\n@media (max-width: 768px) {\n    .kbaImageDetailsText {\n        padding-top: 200px;\n        padding-bottom: 100px;\n        padding-right: 40px;\n    }\n\n    .kbaImageDetailsImage {\n        display: none;\n    }\n\n    .kbaContent {\n        padding: 80px 40px 80px 40px;\n    }\n}\n\n@media (max-width: 992px) {\n    .kbaContainer {\n        min-height: 100vh;\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"kbaContainer": `kbaAuthentication_kbaContainer__3tVGB`,
	"kbaImage": `kbaAuthentication_kbaImage__OO-IT`,
	"kbaImageLogo": `kbaAuthentication_kbaImageLogo__tYgeC`,
	"kbaImageDetails": `kbaAuthentication_kbaImageDetails__mPdEx`,
	"kbaImageDetailsText": `kbaAuthentication_kbaImageDetailsText__Vuo3N`,
	"kbaBackToHome": `kbaAuthentication_kbaBackToHome__BPbqF`,
	"imageContainer": `kbaAuthentication_imageContainer__SCs93`,
	"kbaTitle": `kbaAuthentication_kbaTitle__cgII9`,
	"kbaKnowledgeBasedText": `kbaAuthentication_kbaKnowledgeBasedText__G0o15`,
	"kbaBassaText": `kbaAuthentication_kbaBassaText__zRpWV`,
	"kbaRadioInputsContainer": `kbaAuthentication_kbaRadioInputsContainer__80LMh`,
	"kbaRadioInputs": `kbaAuthentication_kbaRadioInputs__TSAxW`,
	"kbaSubmit": `kbaAuthentication_kbaSubmit__LdKit`,
	"kbaContent": `kbaAuthentication_kbaContent__ege23`,
	"authSuccess": `kbaAuthentication_authSuccess__MeOc6`,
	"kbaImageDetailsImage": `kbaAuthentication_kbaImageDetailsImage__ErcH2`
};
export default ___CSS_LOADER_EXPORT___;
